import { render, staticRenderFns } from "./NovosTempos.vue?vue&type=template&id=6d4e87c8&scoped=true&lang=pug&"
import script from "./NovosTempos.vue?vue&type=script&lang=js&"
export * from "./NovosTempos.vue?vue&type=script&lang=js&"
import style0 from "./NovosTempos.styl?vue&type=style&index=0&id=6d4e87c8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4e87c8",
  null
  
)

export default component.exports